import { Observable } from 'rxjs';
import { CommonDataModel, ResponseFromServer } from '../../shared/_models';
import { DealBrand } from './deal-brand.model';
import { RxDealsHttpClient } from '../../shared/_services/server-clients';

export class ExchangeBrandsApiService {
  constructor(private readonly rxDealsHttpClient: RxDealsHttpClient) {}

  getBrands(filters: string = ''): Observable<CommonDataModel<DealBrand[]>> {
    return this.rxDealsHttpClient.getExpanded<DealBrand[]>(`deal-brands?${filters}`);
  }

  getBrand(brandId: number): Observable<ResponseFromServer<DealBrand>> {
    return this.rxDealsHttpClient.get<DealBrand>(`deal-brands/${brandId}`);
  }

  createBrand(brand: DealBrand): Observable<ResponseFromServer<DealBrand>> {
    return this.rxDealsHttpClient.post<DealBrand, DealBrand>('deal-brands', brand);
  }

  updateBrand(brandId: number, brand: DealBrand): Observable<ResponseFromServer<DealBrand>> {
    return this.rxDealsHttpClient.put<DealBrand, DealBrand>(`deal-brands/${brandId}`, brand);
  }
}
